import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService, GET, Adapter, POST, Body, Query } from '@royalty/httpclient';

@Injectable()
export class CouponService extends HttpService {
	/**
	 * Discounts
	 */
	@GET('coupondiscount/list')
	@Adapter(null, { isAdmin: true })
	getDiscounts(): Observable<any> {
		return null;
	}

	@POST('coupondiscount/create')
	@Adapter(null, { isAdmin: true })
	createCoupon(@Body data: string): Observable<any> {
		return null;
	}

	@POST('coupondiscount/edit')
	@Adapter(null, { isAdmin: true })
	updateCoupon(@Body data: string): Observable<any> {
		return null;
	}

	@POST('coupondiscount/delete')
	@Adapter(null, { isAdmin: true })
	deleteCoupon(@Body data: string): Observable<any> {
		return null;
	}
}
